module.exports = __webpack_public_path__ + "media/images/partner/supporter/not_approved/nebenan-f9be3bb5949c427145f615c72250a0a1.png";